(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  var conn = navigator.connection;
  if (conn) {
    if (conn.saveData) return;
    if (conn.effectiveType && /2g/.test(conn.effectiveType)) return;
  }

  var HOVER_DELAY_MS = 65;
  var INITIAL_WARMUP_DELAY_MS = 900;
  var INITIAL_WARMUP_LIMIT = 10;
  var prefetched = Object.create(null);
  var hoverTimer = null;

  function isPrefetchable(link) {
    if (!link || link.tagName !== 'A' || !link.href) return false;
    if (link.hasAttribute('data-no-instant')) return false;
    if (link.hasAttribute('download')) return false;
    if (link.target && link.target !== '_self') return false;

    var rel = link.getAttribute('rel') || '';
    if (/(?:^|\s)(?:external|noreferrer)(?:\s|$)/i.test(rel)) return false;

    var url;
    try { url = new URL(link.href); } catch (e) { return false; }

    if (url.origin !== location.origin) return false;
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
    if (url.pathname === location.pathname && url.search === location.search) return false;
    if (prefetched[url.href]) return false;

    var path = url.pathname;
    if (/^\/(cart|account|admin|checkout|apps|services|tools)(\/|$)/.test(path)) return false;
    if (/\.(?:pdf|zip|dmg|exe|mp4|mp3|mov|avi)$/i.test(path)) return false;

    return true;
  }

  function prefetch(href) {
    if (prefetched[href]) return;
    prefetched[href] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = href;
    l.as = 'document';
    document.head.appendChild(l);
  }

  function onPointer(event) {
    var link = event.target.closest && event.target.closest('a');
    if (!isPrefetchable(link)) return;
    if (hoverTimer) clearTimeout(hoverTimer);
    var href = link.href;
    hoverTimer = setTimeout(function () { prefetch(href); }, HOVER_DELAY_MS);
  }

  function cancelHover() {
    if (hoverTimer) {
      clearTimeout(hoverTimer);
      hoverTimer = null;
    }
  }

  function onTouch(event) {
    var link = event.target.closest && event.target.closest('a');
    if (!isPrefetchable(link)) return;
    prefetch(link.href);
  }

  function warmupInitialLinks() {
    var links = document.querySelectorAll(
      'header a[href], nav a[href], main a[href], footer a[href]'
    );
    var count = 0;

    for (var i = 0; i < links.length && count < INITIAL_WARMUP_LIMIT; i++) {
      if (!isPrefetchable(links[i])) continue;
      prefetch(links[i].href);
      count += 1;
    }
  }

  function scheduleInitialWarmup() {
    if (document.visibilityState === 'hidden') return;

    var run = function () {
      setTimeout(warmupInitialLinks, INITIAL_WARMUP_DELAY_MS);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }
  }

  var passive = { capture: true, passive: true };
  document.addEventListener('mouseover', onPointer, passive);
  document.addEventListener('mouseout', cancelHover, passive);
  document.addEventListener('touchstart', onTouch, passive);
  scheduleInitialWarmup();
})();
